module.exports = __webpack_public_path__ + "static/media/location_dark.dd94ad5e.svg";